module.exports = __webpack_public_path__ + "static/img/Amsterdam.77ce3bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/destination/Amsterdam.jpg
// module id = cKY/
// module chunks = 1